module.exports = __webpack_public_path__ + "media/images/download-3739f52c.svg";